module.exports = __webpack_public_path__ + "img/bg_vocabulary_05.9c85fde5.jpg";